export const domain = "https://e-platapi.aecci.org.in";
// export const domain = "http://localhost:3001";

// Hello;
const endpoints = {
  userAuth: "/user-auth",
  getNewsLetters: "/getNewsLetters",

  // registration api
  createClient: "/createClient",
  checkEmail: "/checkEmail/",
  uploadDocCheckEmail: "/uploadDocCheckEmail/",
  uploadDocumentRegistration: "/uploadDocumentRegistration/",
  collaborationRegister: "/collaborationRegister/",
  loginClient: "/loginClient/",
  forgetPasswordSendOtp: "/forgetPasswordSendOtp/",
  forgetPassword: "/forgetPassword/",
  createTrialClient: "/createTrialClient/",
  sendRegistrationOtp: "/sendRegistrationOtp/",
  verifyRegistrationOtp: "/verifyRegistrationOtp/",

  createCollaboration: "/collab/createCollaboration/",

  // b2b connect request form
  createB2BEventRequest: "/b2b/createB2BEventRequest/",
  createParticipate: "/b2b/createParticipate/",
  getB2bEventRequest: "/b2b/getB2bEventRequest/",
  getInvitationLetter: "/b2b/getInvitationLetter/",
  processB2bPayment: "/b2b/processB2bPayment/",

  //b2b Registration
  // createB2bRegistration: "/b2b/createB2bRegistration/",

  //b2b participates apis
  getParticipateList: "/b2b/getParticipateList/",
  checkSlotBeforeJoin: "/b2b/checkSlotBeforeJoin/",

  //b2b bookings api
  // checkSlotAvailability: "/b2b/checkSlotAvailability/",
  getAvailableTimeSlots: "/b2b/getAvailableTimeSlots/",
  checkCountryAvailability: "/b2b/checkCountryAvailability/",
  checkSlotTimeAvailability: "/b2b/checkSlotTimeAvailability/",
  checkSingleCountryAvailability: "/b2b/checkSingleCountryAvailability/",
  checkCountrySelection: "/b2b/checkCountrySelection/",
  checkDateAvailability: "/b2b/checkDateAvailability/",
  submitB2bReview: "/b2b/submitB2bReview/",
  bookSlot: "/b2b/bookSlot/",
  addB2bFundToWallet: "/addB2bFundToWallet/",

  // profile page apis
  updatePersonalDetalis: "/updatePersonalDetalis/",
  updateCompanyDetails: "/updateCompanyDetails/",
  marketingDetails: "/marketingDetails/",
  changePassword: "/changePassword/",
  updateSocialMedia: "/updateSocialMedia/",

  //Services Apis
  getComDirDetails: "/getComDirDetails/",
  commercialDir: "/commercialDir/",
  clientB2BColloboration: "/clientB2BColloboration/",
  createRecommendationLetter: "/createRecommendationLetter/",
  addFundToWallet: "/addFundToWallet/",
  getWalletHistory: "/getWalletHistory/",
  renewMembership: "/renewMembership/",
  checkMembRenewalExists: "/checkMembRenewalExists/",
  requestCollabRenewal: "/requestCollabRenewal/",
  getLatestMembInvoice: "/getLatestMembInvoice/",
  renewMembershipRazorpay: "/renewMembershipRazorpay/",
  refreshBal: "/refreshBal/",
  createRazorpayOrder: "/createRazorpayOrder/",
  verifyRazorpayPayment: "/verifyRazorpayPayment/",
  //eco apis
  createEco: "/createEco/",
  createMco: "/createMco/",
  getUserEcoData: "/getUserEcoData/",
  getUserMcoData: "/getUserMcoData/",
  createNonStandard: "/createNonStandard/",
  getNonStandDocUser: "/getNonStandDocUser/",
  getStamppedNonStandDocUser: "/getStamppedNonStandDocUser/",
  downDocNonStand: "/downDocNonStand/",

  //Draft Apis
  createEcoDraft: "/createEcoDraft/",
  getAllDraft: "/getAllDraft/",
  deleteDraft: "/deleteDraft/",
  updateDraft: "/updateDraft/",

  //req for upgrade
  upgradeMembership: "/upgradeMembership/",

  // all get req
  getpersonalinfo: "/getpersonalinfo/",
  getCompanyDetails: "/getCompanyDetails/",
  getVisaRecommendationData: "/getVisaRecommendationData/",

  //THE WING APIs--------------------
  createQuery: "/wing/createQuery/",
  getWingDataUser: "/wing/getWingDataUser/",
  getAllMessagesWings: "/wing/getAllMessages/",
  submitReview: "/wing/submitReview/",

  //legal wing apis
  createLegalWingRequest: "/wing/createLegalWingRequest/",

  //Export wing apis
  createExportWingRequest: "/wing/createExportWingRequest/",

  //Professional wing apis
  createProfessionalWingRequest: "/wing/createProfessionalWingRequest/",

  //Hr wing apis
  createHrWingRequest: "/wing/createHrWingRequest/",

  //Business wing apis
  createBusinessWingRequest: "/wing/createBusinessWingRequest/",

  //Event wing apis
  createEventWingRequest: "/wing/createEventWingRequest/",

  //arbitration apis
  createNonBindingDispute: "/arbitration/createNonBindingDispute/",
  getNonBindingDispute: "/arbitration/getNonBindingDispute/",
  nonBindingPaymentProcess: "/arbitration/nonBindingPaymentProcess/",
  updateDisputeDocMessage: "/arbitration/updateDisputeDocMessage/",
  createBindingDispute: "/arbitration/createBindingDispute/",
  updateBindingDispute: "/arbitration/updateBindingDispute/",
  getBindingDispute: "/arbitration/getBindingDispute/",
  addBindingDisputeFund: "/addBindingDisputeFund/",
  addBindingParty: "/arbitration/addBindingParty/",
  getDisputeDetailArbitrator: "/arbitration/getDisputeDetailArbitrator/",
  getArbitratorsList: "/arbitration/getArbitratorsList/",
  addBindingArbitrator: "/arbitration/addBindingArbitrator/",
  createIACUser: "/arbitration/createIACUser/",
  iacLogin: "/arbitration/iacLogin/",

  //publication apis
  getPublication: "/getPublication/",

  //ad booking Apis
  createAdBooking: "/ads/createAdBooking/",
  getAdBooking: "/ads/getAdBooking/",
  getAllAds: "/ads/getAllAds/",
  getAllApprovedAdsData: "/ads/getAllApprovedAdsData/",

  //Event apis
  getEvents: "/getEvents/",
  registerEvent: "/registerEvent/",
  getRegisterEvent: "/getRegisterEvent/",
  createEventBooking: "/createEventBooking/",
  getEventById: "/getEventById/",
  getAllEvents: "/getAllEvents/",

  //independent pages apis
  getVerMembCertStatus: "/getVerMembCertStatus/",
  getVerVisaStatus: "/getVerVisaStatus/",
  getCertOfOrigin: "/getCertOfOrigin/",
  checkEmailExists: "/checkEmailExists/",

  //new b2b apis
  //  for users
  createB2bUserRegistration: "/b2b/createB2bUserRegistration/",

  //  for collaborators
  createB2bRegistration: "/b2b/createB2bRegistration/",
  checkSlotAvailability: "/b2b/checkSlotAvailability/",
  getAllB2bRegistration: "/b2b/getAllB2bRegistration/",
  getParticipateCountries: "/b2b/getParticipateCountries/",
  getParticipateCountriesDetails: "/b2b/getParticipateCountriesDetails/",
  getRegistrationDetail: "/b2b/getRegistrationDetail/",
  getUserBookedSlots: "/b2b/getUserBookedSlots/",
  verifyB2bPayment: "/b2b/verifyB2bPayment/",

  getAllCollaboratorCountries: "/collaborator/getAllCollaboratorCountries/",
  getCollaboratorCountry: "/collaborator/getCollaboratorCountry/",

  getB2bRegistration: "/b2b/getB2bRegistration/",
  updateB2bSlots: "/b2b/updateB2bSlots/",
  addB2bSlot: "/b2b/addB2bSlot/",
  updateB2bParticipants: "/b2b/updateB2bParticipants/",
  updateB2bParticipant: "/b2b/updateB2bParticipant/",

  getB2bBookingHistory: "/b2b/getB2bBookingHistory/",
  getCollaboratorBookedSlots: "/b2b/getCollaboratorBookedSlots/",

  // Waiting Room
  requestJoin: "/waiting-room/requestJoin",
  checkJoinStatus: "/waiting-room/checkStatus",

  // Cloud Meetings
  getCloudMeeting: "/zego/getCloudMeeting/:id",
};

function getURLbyEndPoint(endpoint) {
  return domain + endpoints[endpoint];
}

function getURLbyEndPointV2(endpoint) {
  return domain + "/api/v2" + endpoints[endpoint];
}

export { endpoints, getURLbyEndPoint, getURLbyEndPointV2 };
